export const primaryBusinessActivity = [
  'Construction',
  'Distribution/Wholesale',
  'Information/Software',
  'Maintenance/Repair',
  'Manufacturing',
  'Raw Materials',
  'Rental & Leasing',
  'Retail',
  'Services',
];

export const legalOrganizationStatus = [
  'B Corporation',
  'C Corporation',
  'Limited Liability Company (LLC)',
  'Nonprofit',
  'Partnership',
  'S Corporation',
  'Sole Proprietorship',
];
export const industriesServed = {
  'Manufacturing & Production': [
    'Automotive & Aerospace',
    'Electronics & Semiconductors',
    'Industrial Equipment & Machinery',
    'Consumer Goods & Packaging',
    'Food & Beverage Manufacturing',
  ],
  'Construction & Infrastructure': [
    'Commercial & Residential Construction',
    'Civil Engineering & Infrastructure Development',
    'HVAC & Building Systems',
    'Smart Cities & Sustainable Construction',
  ],
  'Technology & IT Services': [
    'Software Development & SaaS',
    'Cybersecurity & IT Consulting',
    'Cloud Computing & Data Services',
    'AI, Machine Learning & Automation',
    'Telecommunications & Networking',
  ],
  'Professional & Business Services': [
    'Consulting & Advisory Services',
    'HR, Staffing & Workforce Solutions',
    'Marketing & Branding Services',
    'Legal & Compliance Services',
    'Accounting & Financial Services',
  ],
  'Retail, Wholesale & E-commerce': [
    'Consumer Goods & Apparel',
    'Wholesale Distribution',
    'E-commerce & Digital Marketplaces',
    'Luxury & Lifestyle Brands',
  ],
  'Healthcare & Life Sciences': [
    'Medical Devices & Equipment',
    'Pharmaceuticals & Biotechnology',
    'Healthcare IT & Digital Health',
    'Hospitals & Clinical Services',
  ],
  'Energy & Utilities': [
    'Renewable Energy & Sustainability',
    'Oil & Gas Services',
    'Water & Waste Management',
    'Smart Grid & Utility Technologies',
  ],
  'Transportation & Logistics': [
    'Freight & Supply Chain Management',
    'Warehousing & Distribution',
    'Last-Mile Delivery & Courier Services',
    'Fleet Management & Vehicle Leasing',
  ],
  'Aerospace & Defense': [
    'Military & Defense Contracting',
    'Space Technology & Exploration',
    'Aviation & Aircraft Components',
  ],
  'Government & Public Sector': [
    'Federal, State & Local Government Contracting',
    'Education & Public Services',
    'Public Transportation & Infrastructure',
  ],
  'Diversity & Social Impact': [
    'Minority-Owned, Women-Owned, & Veteran-Owned Businesses',
    'Sustainable & Ethical Supply Chains',
    'Nonprofit & Social Enterprises',
  ],
};


export const primaryCustomers = [
  'Business-to-Business (B2B)',
  'Business-to-Consumer (B2C)',
  'Government',
  'Nonprofit',
  'Other',
];

export const revenueChannels = [
  'Direct B2B Sales',
  'Government Contracts',
  'Wholesale & Distribution',
  'Marketplace Platforms',
  'Channel Partnerships & Resellers',
  'Service Contracts & Consulting',
  'Franchising & Licensing',
  'Subscription & Memberships',
  'E-commerce & Online Sales',
  'Private & Corporate Contracts',
];

export const certificationTypes = {
  'Demographic Certification': [
    'None',
    'Minority-Owned Business (MBE)',
    'Women-Owned Business (WBE)',
    'Veteran-Owned Business (VBE)',
    'Service-Disabled Veteran-Owned Business (SDVBE)',
    'LGBTQ+-Owned Business',
    'Disability-Owned Business Enterprise (DOBE)',
    'HUBZone Business (Historically Underutilized Business Zone)',
    'Small Business Enterprise (SBE)',
    'Other',
  ],
  'Industry Certification': [
    'AS9100',
    'AS9110',
    'AS9120',
    'IATF 16949',
    'ISO/IEC 17025',
    'ISO 15189',
    'ISO 26262',
    'ISO 15189',
    'ISO 22000',
    'HACCP',
    'FSSC 22000',
  ],
  'Business Standards Certification': [
    'ISO 9001',
    'ISO 22301',
    'ISO 10002',
    'ISO/IEC 27001',
    'ISO/IEC 27017',
    'ISO/IEC 27018',
    'ISO/IEC 27701',
    'ISO 14001',
    'ISO 50001',
    'CarbonNeutral Certification',
    'LEED Certification',
    'ISO 45001',
    'OSHAS 18001',
    'ISO/IEC 20000-1',
    'CMMI',
    'ISO 31000',
    'ISO 26000',
    'ISO 14067',
    'ISO 28000',
    'CTPAT',
    'SA8000',
    'B Corporation Certification',
    'Other',
  ],
  'Regulatory & Compliance Certifications': [
    'GDPR Compliance',
    'HIPAA Compliance',
    'PCI DSS Compliance',
    'ISO 37001',
    'ISO 37301',
    'ISO/IEC 27701',
    'ISO 27018',
    'SOC 1',
    'SOC 2',
    'SOC 3',
    'RoHS Compliance',
    'REACH Compliance',
    'SOX Compliance',
    'FedRAMP',
    'CCPA Compliance',
    'Other',
  ],
};
